import type { ClspMode } from '../../types'
import type { BallInning } from '../../types/ball'
import { requestApiJsonOrThrow } from '../request-handler'

type GetBallInningsParams = {
  id: string
  mode: ClspMode
}

function getBallInnings(params: GetBallInningsParams): Promise<BallInning[]> {
  const { id, mode } = params

  return requestApiJsonOrThrow<BallInning[]>(`balls/${id}`, {
    params: { mode },
  })
}

export const ballInningsQuery = (params: GetBallInningsParams) => ({
  queryKey: ['ball-inning', params],
  queryFn: () => getBallInnings(params),
})
